import react, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';

//Compnents
import CredencialComum from '../../../components/credencial/credenciamento/CredencialComum';

//Utils
import { getCredencialPronta } from '../../../utils/eventosessioncred';

const Credenciais = () => {
    const [credencial, setCredencial] = useState(false);    
    useEffect(() => {
        setCredencial(getCredencialPronta());
    },[]);

    if(credencial === false){
        return <Spinner animation="border" />;
    }

    return <CredencialComum credencial={credencial} />
}

export default Credenciais;